import VehicleVariantContainer from "containers/Manufacturer/VehicleVariant/index";
import React from "react";


const VehicleVariantPage = () => {
  return (
    <>
      <VehicleVariantContainer/>
    </>
  );
};

export default VehicleVariantPage;